import { Component, NgModule } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { Storage } from '@ionic/storage';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';
import { SearchPhoneSelectListPage } from '../../search/Phone/SearchPhoneSelectListPage';
import { eGENA_Checkliste } from '../../../visionet/Checkliste';
import { eGENA_ItemListe } from '../../../visionet/ItemListe';
import { eGENA_KarteireiterTyp } from '../../../visionet/KarteireiterTyp';
import { ZusatzinformationenPhonePage } from './ZusatzinformationenPhonePage';
import { Wischnavigation } from '../../../Wischnavigation';

import { GlobalConstants } from '../../../app/core/GlobalConstants';


@Component({
	selector: 'page-phone-checklist',
	templateUrl: 'ChecklistPhonePage.html',
})

@NgModule({
	imports: [
		CommonModule
	]
})


export class ChecklistPhonePage {

	karteireiterObenKombination : string = ""; // welche Kombination aus Sofortmaßnahmen, Diagnose und Therapie? Mögliche Werte: S, D, T, SD, ST, SDT, DT
	kareteireiterSymptomeDifferentialdiagnosenCRMs : string[] = ["CRM"]; // Karteireiter für Symptome und Differentialdiagnosen und die beerühmten CRMs
	karteireiterUntenKombination : string = "C"; // welche Kombination aus CRM, Symptome, Differentialdiagnosen? Mögliche WErte: C, CS, CM, CSM
	itemListen: Array<eGENA_ItemListe> = [];
	zeigeZusatzinformationenKarteireiter : Map<eGENA_KarteireiterTyp, boolean> = new Map();
	isloaded: boolean = false;

	crms : any; // Wir verwenden hier explizit NICHT die Klasse eGENA_CRMs sondern behandeln dieses Attribut wie ein assiziatives array = letztlich ein JavaScript-Objekt


	searchType: string = ''
	curPatientType = ""





	checkliste : eGENA_Checkliste; // Diese Checkliste wird hier angezeigt
	aktuelleItemListe: eGENA_ItemListe | undefined = undefined
	aktuelleItemListeAnzeigen: boolean = true;
	aktuellAngezeigteZusatzinformationen: string | undefined = undefined; // Diese zusätzlichen Infromationen (Zusatzinformationen zum Item, CROm, Symptome, Differentialdiagnosen) werden gerade angezeigt.



	constructor(public navCtrl: NavController, public navParams: NavParams, public storage: Storage, public globals: GlobalsSingleton) {
		let checklistenId : string = navParams.get('checklisteId');
		let curSearchType = navParams.get('curSearchType');

		if (checklistenId == undefined) {
			checklistenId = "ch_1";
		}


		if (curSearchType != undefined) {
			this.searchType = curSearchType
		}

		this.storage.get(checklistenId).then((checklistData : eGENA_Checkliste) => {
			this.checkliste = eGENA_Checkliste.fromJSONstring(JSON.stringify(checklistData))[0];
			this.storage.get(GlobalConstants.STORAGE_KEY_TEILNEHMERSPEZIFISCHES).then((teilnehmerspezifisches) => {
				this.crms = teilnehmerspezifisches?.CRMs;
				this.prepareChecklist(checklistData);
			})
		});

		console.info("Checkliste mit ID " + checklistenId);
	}



	ionViewWillEnter() {
		if (this.globals.isIOS())
			Wischnavigation.iosPreventSafariDefaultnav();
	}


	/**	=== Visionet(sl) ==========
	 *	Die Checkliste, die in einer der Trefferlisten der Suche angeklickt wurde wird zur Anzeige aufbereitet:
	 */
	prepareChecklist(checkliste : eGENA_Checkliste) : void {
		this.itemListen = checkliste.karteireiter;
		for (const itemListe of this.itemListen) {
			if (itemListe.typ == eGENA_KarteireiterTyp.Sofortmaßnahmen)
				this.karteireiterObenKombination += "S";
			else if (itemListe.typ == eGENA_KarteireiterTyp.Diagnose)
				this.karteireiterObenKombination += "D";
			else if (itemListe.typ == eGENA_KarteireiterTyp.Therapie)
				this.karteireiterObenKombination += "T";
		}
		this.curPatientType = checkliste.patientengruppe
		this.aktuelleItemListe = this.itemListen[0]
		this.setCurItemList(this.itemListen[0])
		if (checkliste.symptome != undefined) {
			this.kareteireiterSymptomeDifferentialdiagnosenCRMs.push("Symptome");
			this.karteireiterUntenKombination += "S";
		}
		if (checkliste.differentialdiagnosen != undefined) {
			this.kareteireiterSymptomeDifferentialdiagnosenCRMs.push("Differentialdiagnosen");
			this.karteireiterUntenKombination += "D";
		}
		this.isloaded = true;
	}



	/*	Abhängig vom Gerät und der Anzahl der "unteren" Karteireiter muss der dargestellt Text  gekürzt werden:
	 *	Wenn
	 *	- alle 3 Karteireiter anzuzeigen wären
	 *	- und die horizontale Ausdehnung unter ... Pixeln liegt
	 *	- dann kürze "Differentialdiagnosen" zu "Differentialdiag." ab.
	 */
	getKarteireiterLabelOben(liste : eGENA_ItemListe) : string {
		if (this.globals.getWidth() < 370)
			return this.globals.translateKarteireiterPhone(liste.typ, this.karteireiterObenKombination, "extraschmal");
		if (this.globals.getWidth() < 400)
			return this.globals.translateKarteireiterPhone(liste.typ, this.karteireiterObenKombination, "schmal");
		return this.globals.translateKarteireiterPhone(liste.typ, this.karteireiterObenKombination, "");
	}
	getKarteireiterLabelUnten(key : string) : string {
		if (this.globals.getWidth() < 370)
			return this.globals.translateKarteireiterPhone(key, this.karteireiterUntenKombination, "extraschmal");
		if (this.globals.getWidth() < 400)
			return this.globals.translateKarteireiterPhone(key, this.karteireiterUntenKombination, "schmal");
		return this.globals.translateKarteireiterPhone(key, this.karteireiterUntenKombination, "");
	}




	getKarteireiterUntenCSS(karteireiter : string) {
		if (karteireiter.startsWith("Diff"))
			return "Differentialdiagnosen"
		return karteireiter;
	}




	/**	=== Visionet(sl) ==========
	 *	Ist einer der Itemlisten-Karteireiter aktiviert? Rückgabewert ist eine CSS-Klasse:
	 *	- "aktiv"
	 *	- ""
	 */
	isActive(karteireiterTyp : eGENA_KarteireiterTyp, karteireiter : eGENA_KarteireiterTyp) : string {
		if (karteireiterTyp == eGENA_KarteireiterTyp.itemlistenkarteireiter) {
			if (karteireiter == this.aktuelleItemListe.typ) {
				return 'aktiv';
			}
		}

		return "";
	}


	/**	=== Visionet(sl) ==========
	 *	Die Checkliste, die in einer der Trefferlisten der Suche angeklickt wurde
	 */
	goHome(event : UIEvent) : void {
		this.navCtrl.goToRoot(
				{
				animate : true,
				animation: "ios-transition"
			}
		);

	}


	/**	=== Visionet(sl) ==========
	 *	KLick auf einen der Karteireiter Sofortmaßnahmen/Diagnose/Therapie
	 */
	setCurItemList(karteireiter : eGENA_ItemListe) : void {
		this.aktuellAngezeigteZusatzinformationen = undefined;
		this.aktuelleZusatzinformationName = "";
		this.aktuelleItemListe = karteireiter
		this.aktuelleItemListeAnzeigen = true;
	}








	/**	=== Visionet(sl) ==========
	 *	Klick auf die unteren Karteireiter "CRM", "Symptome", "Differentialdiagnosen" bzw. initale Darstellung von CRM
	 */
	handleClickBottomButtons(name: string) : void {
		this.aktuelleItemListeAnzeigen = false;
		this.aktuelleZusatzinformationName = name;
		if (name == "Symptome") {
			if (this.checkliste.symptome != undefined)
				this.aktuellAngezeigteZusatzinformationen = this.setzeHyperlinksInZusatzinformationenEin(this.checkliste.symptome);
			else
				this.aktuellAngezeigteZusatzinformationen = undefined;
		}
		else if (name.startsWith("Diff")) {
			if (this.checkliste.differentialdiagnosen != undefined) {
				this.aktuellAngezeigteZusatzinformationen = this.setzeHyperlinksInZusatzinformationenEin(this.checkliste.differentialdiagnosen);
			}
			else
				this.aktuellAngezeigteZusatzinformationen = undefined;
		}
		else if (name == "CRM") {

			this.aktuellAngezeigteZusatzinformationen = this.crms[this.aktuelleItemListe?.typ];
		}
		else if (name == "Zusatzinformationen") {
			// Wir zeigen die Zusatzinformationen des zuletzt angeklickten Items an
			for (const item of this.aktuelleItemListe.listenElemente) {
				if (item.zusatzinformationenWerdenAngezeigt) {
					this.aktuellAngezeigteZusatzinformationen = this.setzeHyperlinksInZusatzinformationenEin(item.zusatzinformationen);
				}
			}
		}
		else {
			this.aktuellAngezeigteZusatzinformationen = undefined;
		}
	}



	private aktuelleZusatzinformationName:string = "";
	getZusatzinformationenCSS() : string {
		if (this.aktuelleZusatzinformationName.startsWith("Diff"))
			return "Differentialdiagnosen";

		return this.aktuelleZusatzinformationName;
	}



	/**	=== Visionet(sl) ==========
	 *	Als Parameter erhalten wir die ID einer Checkliste und zu dieser Checkliste soll gewechselt werden
	 */
	oeffneAndereCheckliste(infoObject : {checklisteId:string}) : void {
		this.navCtrl.push(ChecklistPhonePage, {
			checklisteId: infoObject.checklisteId,
			curPatientType: this.curPatientType
		},
		{
			animate : true,
			animation: "ios-transition"
		});
	}

	/**	=== Visionet(sl) ==========
	 *	Als Parameter erhalten wir die Zusatzinformationen eines Items und diese Zusatzinformationen sollen dargestellt werden.
	 */
	setZusatzinformationen(infoObject : {zusatzinformationen:string}) :void {
		let infosMitLinks : string = this.setzeHyperlinksInZusatzinformationenEin(infoObject.zusatzinformationen);
		
		
		this.navCtrl.push(ZusatzinformationenPhonePage, {
			zusatzinformationen: infosMitLinks
		},
		{
			animate : true,
			animation: "ios-transition"
		});


		/*		
		this.zeigeZusatzinformationenKarteireiter.set(this.aktuelleItemListe.typ, true);

		this.aktuellAngezeigteZusatzinformationen = this.setzeHyperlinksInZusatzinformationenEin(infoObject.zusatzinformationen);
		*/
	}


	zusatzinformationenKarteireiterAnzeigen() : boolean {
		if (this.zeigeZusatzinformationenKarteireiter.has(this.aktuelleItemListe.typ))
			return this.zeigeZusatzinformationenKarteireiter.get(this.aktuelleItemListe.typ);
		return false;
	}


	private setzeHyperlinksInZusatzinformationenEin(zusatzinformationen : string) : string {
		/*	Jetzt müssen wir alle Links ersetzen.
		 *	Aus einem
		 *
		 *		#1
		 *
		 *	machen wir einen Link der Art
		 *
		 *		<a (click)="linkClick(1);">Titel der Ziel-Checkliste</a>
		 *
		 *	Dabei ist aber zu beachten, dass textile-js viele Sonderzeichen zu HTML-Entites umwandelt.
		 *	Aus
		 *
		 *		'
		 *
		 *	(Apostroph) wird dann leider
		 *
		 *		&#8217;
		 *
		 *	Das sieht dann aus wie ein Link (#8217) aus. Es muss also alles mit "&" vorne dran ignorieren wir.
		 */
		let regex = /(.)\#([0-9]+){(.*?)}(.)/gm
		return zusatzinformationen.replace(regex, (match, $1, $2, $3, $4) => {
			let zeichenVorher : string = $1;
			let ziffern : string = $2;
			let linkName : string = $3
			let zeichenNachher : string = $4;
			if (zeichenVorher == "&" && zeichenNachher == ";")
				return match;

			return `${zeichenVorher}<a class="linkToChecklist" data-checklisteId="${ziffern}">${linkName}</a>${zeichenNachher}`;
		});
	}

}


// WEBPACK FOOTER //
// ./src/pages/checklist/Phone/ChecklistPhonePage.ts